import { IconButton } from '@web/components/atoms/Button'
import { BiOutlineLockClosed, ChevronLeftIcon } from '@web/components/atoms/Icons'
import { Box, HStack } from '@web/components/atoms/Layout'
import { Section2 } from '@web/components/atoms/Typography'
import { useDonationFormContext } from '@web/components/page-components/DonationForm'

type DonationBackHeaderProps = {
  title: string
  withLockIcon?: boolean
  isLoading?: boolean
  hasBackButton?: boolean
}

const DonationBackHeader = ({ title, withLockIcon, isLoading, hasBackButton = true }: DonationBackHeaderProps) => {
  const prevStep = useDonationFormContext((state) => state.actions.prevStep)

  return (
    <Box w="100%" position="relative">
      {hasBackButton && (
        <Box position="absolute" top={0} left={0}>
          <IconButton buttonAppearance="text" id="back-to-start" onClick={prevStep} size="md" disabled={isLoading}>
            <ChevronLeftIcon />
          </IconButton>
        </Box>
      )}
      <HStack justifyContent="center" mt="8px">
        {withLockIcon && <BiOutlineLockClosed h="25px" w="25px" />}
        <Section2>{title}</Section2>
      </HStack>
    </Box>
  )
}

export default DonationBackHeader
